import { array as codecArray } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, paginated, requestParams } from '@codegrade/api-core';
import { ConnectRepositoryGitProviderData, CreateRepositoryGitProviderData, GitRepositoryLike, Job, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function gitProvider(config) {
    const connectRepositoryResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Job)),
    });
    const createRepositoryResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(Job)),
    });
    const getAllRepositoriesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(GitRepositoryLike))),
    });
    const getAllTemplatesResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ paginated.makeResult(
        /* #__PURE__ */ parseJsonResponse(/* #__PURE__ */ codecArray(GitRepositoryLike))),
    });
    return Object.freeze({
        /**
         * Connect an existing repository to an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider from which you want to connect the repo.
         * @param arg.tokenId The id of the token used for authentication.
         * @param arg.repositoryId The id of the repo to connect.
         * @param arg.isTestStudent Is this webhook for the test student?
         * @param arg.authorId The id of the user for which we should get the webhook settings.
         * @param arg.requestBody The body of the request.
         * @returns A job that will be started to connect and clone the repository.
         */
        connectRepository: async ({ providerId, tokenId, repositoryId, isTestStudent, authorId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/git_providers/${providerId}/tokens/${tokenId}/repositories/${repositoryId}/connect`, connectRepositoryResponse.v, JSON.stringify(ConnectRepositoryGitProviderData.encode(requestBody)), {
                is_test_student: isTestStudent,
                author_id: authorId,
            });
            return result;
        },
        /**
         * Create a new repository and connect it to an assignment.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider in which you want to create a new repo.
         * @param arg.tokenId The id of the token used for authentication.
         * @param arg.isTestStudent Is this webhook for the test student?
         * @param arg.authorId The id of the user for which we should get the webhook settings.
         * @param arg.requestBody The body of the request.
         * @returns A job that will be started to connect and clone the repository.
         */
        createRepository: async ({ providerId, tokenId, isTestStudent, authorId, requestBody, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/git_providers/${providerId}/tokens/${tokenId}/repositories/`, createRepositoryResponse.v, JSON.stringify(CreateRepositoryGitProviderData.encode(requestBody)), {
                is_test_student: isTestStudent,
                author_id: authorId,
            });
            return result;
        },
        /**
         * Get all repositories for the given git provider.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider from which you want to retrieve repos.
         * @param arg.tokenId The token to use to retrieve the repos.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns The token.
         */
        getAllRepositories: async ({ providerId, tokenId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/git_providers/${providerId}/tokens/${tokenId}/repositories/`, getAllRepositoriesResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
        /**
         * Get all template repositories for the given git provider.
         *
         * Note: We do not yet support GitLab templates.
         *
         * @param arg The arguments to the function.
         * @param arg.providerId The provider from which you want to retrieve repos.
         * @param arg.tokenId The token to use to retrieve the repos.
         * @param arg.pageSize The size of a single page, maximum is 50.
         * @param arg.nextToken The next token, to retrieve a next page.
         * @returns The token.
         */
        getAllTemplates: async ({ providerId, tokenId, pageSize = undefined, nextToken = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/git_providers/${providerId}/tokens/${tokenId}/templates/`, getAllTemplatesResponse.v, undefined, {
                'page-size': pageSize,
                'next-token': nextToken,
            });
            return result;
        },
    });
}
